"use client";
import classNames from "classnames";
import { BasicProps } from "components/types/BasicProps";
import currenciesModule from "logic/CurrenciesModule";
import { FC, useState } from "react";
import { TokenRow } from "./TokenRow";
import { ICurrency } from "logic/types/currency/ICurrency";

const TOKENS = currenciesModule.tokens;

export const Tokens: FC<BasicProps> = (props) => {
  const { className } = props;
  const [sensor, toggle] = useState<boolean>(false);

  const handleTransactionDone = () => {
    toggle(!sensor);
  };

  return (
    <ul
      className={classNames(
        "w-full flex flex-col gap-[15px] justify-center",
        className
      )}
    >
      {TOKENS.map((token) => (
        <TokenRow
          token={token}
          refreshTransactions={sensor}
          onTransactionDone={handleTransactionDone}
        />
      ))}
    </ul>
  );
};
